// apps/web/src/pages/NotFoundPage.tsx
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft, Compass } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center max-w-md mx-auto animate-fade-in">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gray-100 dark:bg-gray-800 mb-6">
          <Compass className="w-12 h-12 text-gray-400" />
        </div>
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">404</h1>
        <h2 className="text-xl font-medium text-gray-700 dark:text-gray-300 mb-4">找不到此頁面</h2>
        <p className="text-gray-500 dark:text-gray-400 mb-8 max-w-sm mx-auto leading-relaxed">
          抱歉，您找尋的頁面不存在，或許已被移動或刪除。
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/directory" className="btn-primary">
            <Search className="w-4 h-4 mr-2" />
            去校友名冊逛逛
          </Link>
          <Link to="/" className="btn-secondary">
            <Home className="w-4 h-4 mr-2" />
            回首頁
          </Link>
        </div>
        <p className="mt-8 text-sm text-gray-400 dark:text-gray-500">
          或 <button onClick={() => window.history.back()} className="underline hover:text-alumni-600">返回上一頁</button>
        </p>
      </div>
    </div>
  );
}